import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import SingleSegmentParagraph from './SingleSegmentParagraph';
import MultiSegmentParagraph from './MultiSegmentParagraph';
import useGuideStore from '../../store/guide';
import { DialogWindow } from '../DialogWindow';
import Button from '../core/Button';

const Guide: FC = () => {
  const intl = useIntl();
  const {
    open,
    setClosed,
    subjects,
    selectedSubjectId,
    openGuide,
    selectedChapters,
  } = useGuideStore();

  const onLinkClick = useCallback(
    (targetId: string) => {
      openGuide(targetId);
    },
    [openGuide],
  );

  return (
    <DialogWindow
      open={open}
      onOpenChange={(isOpen) => !isOpen && setClosed()}
      title={intl.formatMessage({ id: 'guide.guide', defaultMessage: 'Guide' })}
      contentClassName="p-0"
      content={
        <div className="flex max-h-[78vh] min-h-[78vh] flex-row items-stretch gap-4">
          <div className="max-h-[78vh] min-h-[78vh] w-[300px] overflow-auto p-2 pr-0">
            <h5 className="ml-4 mt-4">
              <FormattedMessage id="guide.subjects" defaultMessage="Subjects" />
            </h5>
            <ul>
              {subjects.map((s) => (
                <li key={s.id}>
                  <Button
                    onClick={() => openGuide(s.id)}
                    variant={s.id === selectedSubjectId ? 'filled' : 'ghost'}
                    className="w-full justify-start"
                  >
                    {s.title}
                  </Button>
                </li>
              ))}
            </ul>
          </div>
          <div className="max-h-[78vh] min-h-[78vh] flex-1 overflow-auto bg-background-200 p-4 pt-2">
            {!selectedChapters && (
              <p className="text-sm leading-6">
                <FormattedMessage
                  id="guide.select_subject"
                  defaultMessage="Select subject on the left"
                />
              </p>
            )}
            {selectedChapters &&
              selectedChapters.map((c) => (
                <div key={c.id}>
                  <h5 className="mb-1 mt-4">{c.heading}</h5>
                  {c.paragraphs.map((p, i) => {
                    if (Array.isArray(p)) {
                      return (
                        <MultiSegmentParagraph
                          key={c.id + i}
                          segments={p}
                          onLinkClick={onLinkClick}
                        />
                      );
                    }
                    return (
                      <SingleSegmentParagraph
                        key={c.id + i}
                        segment={p}
                        onLinkClick={onLinkClick}
                      />
                    );
                  })}
                </div>
              ))}
          </div>
        </div>
      }
      className="max-w-[1200px]"
    />
  );
};

export default Guide;
